export const formatAndValidatePhone = (input) => {
  console.log('formatAndValidatePhone called', input)
  
  // Remove all non-digit characters
  const cleaned = input.replace(/\D/g, '');

  // Must be exactly 10 digits (US number)
  if (cleaned.length !== 10) return null;

  // Format into XXX-XXX-XXXX
  const formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;

  return formatted;
};
